// Firebase configuration
import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCX0586gM2b_yefQCrEdryZhD5CR58SrmY",
  authDomain: "sostegno-pro.firebaseapp.com",
  projectId: "sostegno-pro",
  storageBucket: "sostegno-pro.firebasestorage.app",
  messagingSenderId: "901299985809",
  appId: "1:901299985809:web:d999c82deba8641440ce30",
  measurementId: "G-RQ2L2MWFXW"
};

// Initialize Firebase
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
export default firebaseConfig;